import * as React from 'react';
import { motion } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper } from './AnimateIcon';

const animations = {
  default: {
    lid: {},
    body: {},
    lines: {},
  },
  trash: {
    lid: {
      initial: { rotate: 0 },
      animate: {
        rotate: [-45, 0],
        transition: { duration: 0.45, ease: 'easeInOut' },
      },
    },
    body: {},
    lines: {},
  },
};

function IconComponent({ size, ...props }) {
  const { controls } = useAnimateIconContext();
  const variants = getVariants(animations);

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* lid — klappt um linkes Scharnier auf */}
      <motion.g variants={variants.lid} initial="initial" animate={controls} style={{ originX: '12%', originY: '100%' }}>
        <path d="M3 6h18" />
        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
      </motion.g>
      {/* body + lines — static */}
      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
      <line x1="10" x2="10" y1="11" y2="17" />
      <line x1="14" x2="14" y1="11" y2="17" />
    </motion.svg>
  );
}

function Trash2(props) {
  return <IconWrapper icon={IconComponent} {...props} />;
}

export { animations, Trash2, Trash2 as Trash2Icon };
